import {
    openDesktopNav,
    closeDesktopNav,
    closeAllDesktopMainNavs,
    closeAllDesktopUtilityNavs,
    openLoginDropdown,
    closeLoginDropdown,
    closeAllDesktopDropdowns,
    openDesktopLocationSelect,
    closeDesktopLocationSelect
} from '../menus.js';

function initMobileNavKeyboardNavigation() {
    //main nav keyboard navigation
    $('body').on('keydown', '#mobileNav', function (e) {
        var target = $(e.target),
            menu = $(e.target).closest('.trigger-container').find('.meganav-trigger, .standard-link'),
            submenu,
            submenuContainer;

        //ignore keyboard events from inside search/location
        if (target.closest('.search-form-container, .my-location').length > 0) {
            return;
        }

        if (e.which == 27) { //esc

            let container = target.closest('.mobilenav-submenu-inner-wrapper');
            if (container.length == 0) {
                container = target.closest('.top-subnav');
            }

            if (container.length == 0) {
                container = target.closest('.utility-sub');
            }

            let focus = $('#mobileNav a[data-submenu="' + container.attr('id') + '"]');

            if (container.length > 0) {
                container.find('.back-nav-item a').trigger('click');
                focus.addClass('keyboard-focus').on('blur', function () {
                    $(this).off('blur').removeClass('keyboard-focus');
                }).get(0).focus();
            } else {
                $('.mobile-menu-toggle').trigger('click').addClass('keyboard-focus').on('blur', function () {
                    $(this).off('blur').removeClass('keyboard-focus');
                }).get(0).focus();
            }

            return false;
        } else if (e.which == 13) { //enter

            if (target.is('[data-submenu]')) {
                $('#' + target.data('submenu')).find('a').not('.back-nav-item a').first().addClass('keyboard-focus').on('blur', function () {
                    $(this).off('blur').removeClass('keyboard-focus');
                }).get(0).focus();

                return false;
            }

        } else if (e.which == 40) { //down arrow

            let anchors = $('#mobileNav a[tabindex="0"]');
            let index = anchors.index(target);

            let newIndex = index + 1;

            if (newIndex >= anchors.length) {
                newIndex = 0;
            }

            $(anchors.get(newIndex)).addClass('keyboard-focus').on('blur', function () {
                $(this).off('blur').removeClass('keyboard-focus');
            }).get(0).focus();

            return false;

        } else if (e.which == 38) { //up arrow
            let anchors = $('#mobileNav a[tabindex="0"]');
            let index = anchors.index(target);

            let newIndex = index - 1;

            if (newIndex < 0) {
                newIndex = anchors.length - 1;
            }

            $(anchors.get(newIndex)).addClass('keyboard-focus').on('blur', function () {
                $(this).off('blur').removeClass('keyboard-focus');
            }).get(0).focus();

            return false;
        } else if (e.which == 37) { //left arrow

            if (target.is('.back-nav-item a')) {
                target.trigger('click');
            }

            return false;

        } else if (e.which == 39) { //right arrow

            if (target.is('.mainnav-trigger, .meganav-trigger')) {
                target.trigger('click');
            }

            return false;

        } else if (e.which == 36) { //home key

            let anchors = $('#mobileNav a[tabindex="0"]');
            
            anchors.first().addClass('keyboard-focus').on('blur', function () {
                $(this).off('blur').removeClass('keyboard-focus');
            }).get(0).focus();

            return false;

        } else if (e.which == 35) { //end key

            let anchors = $('#mobileNav a[tabindex="0"]');
            
            anchors.last().addClass('keyboard-focus').on('blur', function () {
                $(this).off('blur').removeClass('keyboard-focus');
            }).get(0).focus();

            return false;

        }
    });

    $('body').on('keyup', '*', function (e) {
        if ($(e.target).closest('#mobileNav').length == 0 && $('#mobileNav').is('.open')) {
            $('.mobile-menu-toggle').trigger('click');
        }
    });
}

export { initMobileNavKeyboardNavigation };